import { Box } from "@react-three/flex";
import GeoFlex from "../Flexes/GeoFlex";
import TxtFlex from "../Flexes/TxtFlex";

function LanguageBox({ 
  align, 
  scale, 
  handleThreshold, 
  viewport,
}) {

  return(
    <>
      {/* <Box
        dir='column' 
        align={align} 
        justify='center'
        width='100%'
        minHeight='50%'
        height='auto'
        margin={scale}
      > */}
        <Box
          dir='row'
          marginLeft={3 * scale}
          justify='space-evenly'
        >
          <Box
            marginRight={2 * scale}
          >
            <GeoFlex
              scale={scale}
              onReflow={handleThreshold}
              align='center'
              color='red'
              cone        
            />
          </Box>
          <Box
            marginLeft={4 * scale}
          >
            <TxtFlex 
              scale={scale}
              onReflow={handleThreshold}
              text={'JS\nHTML5'}
              textTwo={'SQL\nCSS3'}
              txtColorOne='white'
              txtColorTwo='#009092'
              textScaleFactor={1.075 * scale}
              align='center'
              justify='flex-end'
              textAlign='right'
              />
          </Box>
        </Box>
        <Box
          dir='row'
          marginLeft={3 * scale}
          justify='space-evenly'
        >
          <Box
            marginRight={4 * scale}
          >
            <TxtFlex 
              scale={scale}
              onReflow={handleThreshold}
              text={'React\nNode.js'}
              textTwo={'Jest\nExpress.js'}
              txtColorOne='white'
              txtColorTwo='red'
              textScaleFactor={1.075 * scale}
              align='center'
              justify='center'
              textAlign='left'
              width='100%'
              marginRight={2.25 * scale}
            />
          </Box>
          <Box
            marginRight={2 * scale}
          >
            <GeoFlex
              scale={scale}
              onReflow={handleThreshold}
              // align='center'
              // justify='center'
              color='#009092'              
              invert
              cone        
            />
          </Box>
        </Box>  
      {/* </Box>   */}
    </>
  );
};

export default LanguageBox;